import { useEffect, useState } from 'react';

export const useSubdomainRedirect = () => {
    const [shouldRender, setShouldRender] = useState(false);

    useEffect(() => {
        const location: Location = window.location;
        const { hostname, pathname, protocol, search } = location;

        let envDomain = '';
        let needsPort = false;

        if (hostname.includes('localhost')) {
            envDomain = '.launchoperator.localhost';
            needsPort = true;
        } else {
            const hostEnv = hostname.includes('.dev.') ? '.dev' : '';
            envDomain = `${hostEnv}.launchoperator.com`;
        }

        const baseMainDomain = `app${envDomain}`;
        const fullMainDomain = `${baseMainDomain}${needsPort ? ':3001' : ''}`;

        if (hostname !== baseMainDomain && hostname.endsWith(envDomain)) {
            const orgId = hostname.split('.')[0];

            let newPath = pathname;
            const orgPathMatch = newPath.match(/^\/org\/[^/]+(\/.*)?$/);
            if (orgPathMatch) {
                const afterOrg = orgPathMatch[1] || '';
                newPath = afterOrg || '/';
            }

            const finalPath = `/org/${orgId}${newPath}`;
            const newUrl = `${protocol}//${fullMainDomain}${finalPath}${search}`;

            window.location.replace(newUrl);
        } else {
            setShouldRender(true);
        }
    }, []);

    return shouldRender;
};